import React,{useState, useEffect} from "react";
// import SalesReportPage from "../../../../entities/DashboardPage/AccountingModule/Customer/SalesReport";
import SalesReportPage from "../../../../../entities/DashboardPage/AccountingModule/Customer/SalesReport";

import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
// import AuthService from "../../../api/AuthService";
// eslint-disable-next-line import/default

const SalesReport = () => {
  const [data,setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);


  useEffect(() => {
    getSalesList("","",page);
  },[page])
  const getSalesList = async(text,sort,page) =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSales(text,sort,page);
      if (result?.success) { 
        setData(result?.data?.sales);
        setTotal(result?.data?.total);

        LoaderHelper.loaderStatus(false);
        
        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteSales(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);

        getSalesList();
        // console.slog(result?.success,"new employe data ---")
      } else {
        LoaderHelper.loaderStatus(false);
        // showAlert(result?.message,"error")
        
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    //   showAlert(error,"success")
      // Handle error
      //   alertErrorMessage(error);
    }
  };
  const handleFilter = (text,sort) => {
    text ? getSalesList(text):sort ? getSalesList("",sort):null
  }


  return (
    <SalesReportPage page={page} total={total} setPage={setPage} data={data} handleFilter={handleFilter} handleDelete={handleDelete}/>
  )



}

export default SalesReport;
